import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { BRAND_COLORS, alpha } from '../../../../styles/theme';

interface InspectionInfoDialogProps {
  open: boolean;
  onClose: () => void;
  inspectionInfo: {
    title: string;
    instructions: string;
  } | null;
}

export const InspectionInfoDialog: React.FC<InspectionInfoDialogProps> = ({
  open,
  onClose,
  inspectionInfo
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle sx={{ color: BRAND_COLORS.forestGreen.main }}>
        {inspectionInfo?.title}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ whiteSpace: 'pre-line', lineHeight: 1.6 }}>
          {inspectionInfo?.instructions}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: BRAND_COLORS.forestGreen.main,
            '&:hover': { backgroundColor: alpha(BRAND_COLORS.forestGreen.main, 0.8) }
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
